import React from 'react';
import { AphPageLoader, AphPagination } from '@aph/common-react';

/**
 * ISearchResultsWrapper
 *
 * @description Component properties for SearchResultsWrapper
 * @property {boolean | undefined} loading          Is loading search
 * @property {object | undefined}  paginationConfig Pagination configuration
 * @property {React.ReactNode}     children         Children
 */
interface ISearchResultsWrapper {
  loading?: boolean;
  paginationConfig?: {
    currentPage: number;
    totalResults: number;
    pageSize: number;
    onPaginate: (selectedPage: number) => Promise<void>;
  };
  children: React.ReactNode;
}

/**
 * SearchResultsWrapper
 *
 * @description Wrapper component to standardise the search results and pagination
 */
const SearchResultsWrapper: React.FC<ISearchResultsWrapper> = ({ loading, paginationConfig, children }) => {
  if (loading) {
    return <AphPageLoader text='Loading search...' />;
  }

  return (
    <div className='library-publication-search__search-results'>
      {children}
      {
        paginationConfig &&
        paginationConfig.totalResults > 0 &&
        <div style={{ marginTop: '20px' }}>
          <AphPagination
            {...paginationConfig}
            showSizeChanger={false}
          />
        </div>
      }
    </div>
  );
};

export default SearchResultsWrapper;